/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2017, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/


import React from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'

import {
  SvgIcon
} from '../'

export const Modal = React.forwardRef(({ heading, subHeading, body, footer, sizeLarge, sizeXLarge, contentPadding, onCloseClick, className, containerClassName, contentClassName, buttonIconInverse, elementId }, ref) => {
  const modalEl = elementId ? document.getElementById(elementId) : document.getElementById('modals')

  return ReactDOM.createPortal(
    <div className={`${sizeLarge || sizeXLarge ? "slds-modal_large " : ''}${className ? className : ''}`}>
      <section
        role="dialog"
        tabIndex="-1"
        aria-labelledby="modal-heading-01"
        aria-describedby="modal-content-id-1"
        className="slds-modal slds-fade-in-open">
        <div className={`slds-modal__container${sizeXLarge ? ' modalXL' : ''}${containerClassName ? ` ${containerClassName}` : ''}`}>
          {!heading && onCloseClick
              ? <header style={{ position: 'relative' }}>
                  <button
                    className={`slds-button slds-button_icon slds-modal__close slds-button_icon${buttonIconInverse && '-inverse'}`}
                    title="Close"
                    onClick={onCloseClick}>
                    <SvgIcon
                      variant="utility"
                      symbol="close"
                      buttonIcon={true}
                      size="small"
                      colour="inverse"
                    />
                    <span className="slds-assistive-text">Close</span>
                  </button>
                </header>
              : heading &&
                <header className="slds-modal__header">
                  {onCloseClick &&
                    <button
                      className={`slds-button slds-button_icon slds-modal__close slds-button_icon${buttonIconInverse && '-inverse'}`}
                      title="Close"
                      onClick={onCloseClick}>
                      <SvgIcon
                        variant="utility"
                        symbol="close"
                        buttonIcon={true}
                        size="small"
                        colour="inverse"
                      />
                      <span className="slds-assistive-text">Close</span>
                    </button>
                  }
                  <h2 id="modal-heading-01">
                    {heading}
                  </h2>
                </header>
          }
          <div
            className={`slds-modal__content${contentPadding !== 'none' ? ` slds-p-around_${contentPadding}` : ''}${contentClassName ? ` ${contentClassName}` : ''}`}
            id="modal-content-id-1"
            ref={ref}>
            {subHeading &&
              <div className="slds-p-bottom_medium slds-align_absolute-center">
                {subHeading}
              </div>
            }
            {body}
          </div>
          {footer &&
            <footer className="slds-modal__footer">
              {footer}
            </footer>
          }
        </div>
      </section>
      <div className="slds-backdrop slds-backdrop_open"></div>
    </div>,
    modalEl
  )
})

Modal.propTypes = {
  heading: PropTypes.string,
  subHeading: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element
  ]),
  body: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.string
  ]),
  footer: PropTypes.element,
  onCloseClick: PropTypes.func,
  sizeLarge: PropTypes.bool,
  contentPadding: PropTypes.oneOf([ 'none', 'xxx-small', 'xx-small', 'x-small', 'small', 'medium', 'large', 'x-large', 'xx-large']),
  elementId: PropTypes.string,
  className: PropTypes.string,
  buttonIconInverse: PropTypes.bool,
  style: PropTypes.object
}

Modal.defaultProps = {
  contentPadding: 'large',
  buttonIconInverse: true
}



// WEBPACK FOOTER //
// ./src/components/modal/index.js